import styled from 'styled-components';
import WhyOCA from '../WhyOCA/WhyOCA';
import LandingWrapper from '../LandingWrapper/LandingWrapper';
import BackgroundSVG from './Components/BackgroundSVG/BackgroundSVG';
import HeaderImage from '../assets/HeaderImage.png';
import { Paragraph } from '../Paragraph/Paragraph';
import { useWindowWidth } from '../../../../../hooks/useWindowWidth';
import { Title } from '../Title/Title';
import { Button } from '../Button/Button';
import { forwardRef } from 'react';

interface HeaderProps {
  mainProductPriceWithEHIC?: number;
  mainProductPriceWithoutEHIC?: number;
  ref?: React.Ref<HTMLDivElement>;
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(
  ({ mainProductPriceWithEHIC, mainProductPriceWithoutEHIC }, ref) => {
    const width = useWindowWidth();

    const paragraphText =
      'The most complete student insurance for <strong>academic mobilities</strong>.';
    const titleText =
      'Enjoy a <span style="color: #05C793;">worry-free</span> European <span style="color: #05C793;">exchange</span>';
    const titleText01 = 'Enjoy a';
    const titleText02 =
      '<span style="color: #05C793;">worry-free</span> European <span style="color: #05C793;">exchange</span>';
    const buttonText = 'Get a quote now';
    const buttonId = 'Header_ImInterested_Button';

    const coveragePrice = mainProductPriceWithoutEHIC;
    const coveragePrice2 = mainProductPriceWithEHIC;
    const coveragePriceText = `Full coverage for only <strong>${coveragePrice}€</strong> per month`;
    const lastText = `Or just <strong>${coveragePrice2}</strong> per month with the European Health Insurance Card (EHIC)`;

    return (
      <>
        <Background>
          <Wrapper>
            <LandingWrapper>
              <TopHeader>
                {width > 1024 ? (
                  <>
                    <LeftElement>
                      <ParagraphAlt text={paragraphText} justification='left' maxWidth='554px' />
                      <TextWrapper>
                        <Title textWithBreaks={titleText01} justification='left' size='small' />
                        <Title text={titleText02} justification='left' size='small' />
                      </TextWrapper>
                      <Button href='/onboarding' maxWidth='185px' id={buttonId}>
                        {buttonText}
                      </Button>
                      {coveragePrice != null && coveragePrice !== 0 && (
                        <CoverageWrapper>
                          <CoveragePrice dangerouslySetInnerHTML={{ __html: coveragePriceText }} />
                          <BottomText text={lastText} color='dark' justification='left' />
                        </CoverageWrapper>
                      )}
                    </LeftElement>
                    <RightElement>
                      <Image src={HeaderImage} alt='Header Image' />
                    </RightElement>
                  </>
                ) : (
                  <SingleElement>
                    <Paragraph text={paragraphText} justification='center' />
                    <Title text={titleText} justification='center' size='small' />
                    <Image src={HeaderImage} alt='Header Image' />
                    <Button href='/onboarding' maxWidth='210px' id={buttonId}>
                      {buttonText}
                    </Button>
                    {coveragePrice != null && coveragePrice !== 0 && (
                      <CoverageWrapper>
                        <CoveragePrice dangerouslySetInnerHTML={{ __html: coveragePriceText }} />
                        <BottomText text={lastText} color='dark' justification='left' />
                      </CoverageWrapper>
                    )}
                  </SingleElement>
                )}
              </TopHeader>
              <WhyOCA ref={ref} />
            </LandingWrapper>
          </Wrapper>
          <StyledBackgroundSVG className='absolute top-0 left-0 w-full h-auto' />
        </Background>
      </>
    );
  }
);

export default Header;

const Background = styled.div`
  position: relative;
  background: rgba(255, 246, 239, 0.6);
  width: 100%;
  display: flex;
  padding: 100px 0 140px 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 0;

  @media (min-width: 768px) {
    padding: 200px 0 250px 0;
  }

  @media (min-width: 1024px) {
    padding: 216px 0 250px 0;
  }
`;

const Wrapper = styled.div`
  z-index: 2;
  width: 100%;
  max-width: 1248px;
`;

const TopHeader = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 120px;
  margin-bottom: 54px;
  flex-direction: column;

  @media (min-width: 768px) {
    margin-bottom: 170px;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 0;
    margin-bottom: 200px;
  }
`;

const SingleElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 24px;

  @media (min-width: 768px) {
    gap: 48px;
  }
`;

const LeftElement = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
  }

  @media (min-width: 1024px) {
    width: 55%;
    gap: 30px;
  }
`;

const ParagraphAlt = styled(Paragraph)`
  font-size: 20px;
  line-height: 25px;

  @media (min-width: 768px) {
    font-size: 30px;
    line-height: 35px;
  }
`;

const CoverageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media (min-width: 768px) {
    align-items: flex-start;
  }
`;

const BottomText = styled(Paragraph)`
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  @media (min-width: 1024px) {
    text-align: left;
  }
`;

const TextWrapper = styled.div``;

const RightElement = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 1024px) {
    width: 45%;
    justify-content: flex-end;
  }
`;

const Image = styled.img`
  width: 100%;

  @media (min-width: 768px) {
    max-width: 572px;
  }
`;

const CoveragePrice = styled.p`
  color: #283288;
  text-align: center;
  font-family: 'League Spartan';
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #05c793;
  padding: 10px 20px;
  width: fit-content;

  strong {
    font-weight: 700;
    font-size: 30px;
  }

  @media (min-width: 768px) {
    font-size: 25px;

    strong {
      font-weight: 700;
      font-size: 40px;
    }
  }

  @media (min-width: 1024px) {
    text-align: left;
  }
`;

const StyledBackgroundSVG = styled(BackgroundSVG)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;
